import {ImportingDataTypes} from "../../types";
import {createInvalidPartSection, PreventionInvalidityCode} from "./shared";

export const preventativeInteraction = {
    datasourceId: ImportingDataTypes.partSerializability,
    sections: [
        createInvalidPartSection(),
        {
            sectionKey: 'invalidSerializability',
            sectionTitle: 'Invalid Serializability Values',
            invalidityCode: PreventionInvalidityCode.INVALID_BOOLEAN,
            fields: [
                {
                    key: 'partNumber',
                    label: 'Part Number',
                    type: 'text',
                    extractValue: (o) => typeof o === 'string' ? o : o?.partNo ?? null, // partNo is explicitly used since autocomplete provides partNo field
                    modifyRow: (row, val) => ({...row, partNumber: val})
                },
                {
                    key: 'isSerialized',
                    label: 'Is Serialized',
                    type: 'toggle',
                    modifyRow: (row, val) => ({...row, isSerialized: val})
                },
            ]
        }
    ],
};
